import { createContext, useContext } from "react";
import { get } from "react-hook-form";
import type { FieldErrors, FieldPath, FieldValues } from "react-hook-form";

/** Context for prefixing field paths in nested forms. */
export const FormFieldPathPrefixContext = createContext<string | undefined>(
  undefined,
);

export const useFieldPathWithPrefix = <
  TFieldValues extends FieldValues = FieldValues,
>(
  name: FieldPath<TFieldValues>,
): string => {
  const prefix = useContext(FormFieldPathPrefixContext);
  return prefix ? `${prefix}.${name}` : name;
};

export const useFieldErrorWithPrefix = <
  TFieldValues extends FieldValues = FieldValues,
>(
  errors: FieldErrors<TFieldValues>,
  name: FieldPath<TFieldValues>,
): string | undefined => {
  const prefix = useContext(FormFieldPathPrefixContext);
  const fullPath = prefix ? `${prefix}.${name}` : name;

  const error = get(errors, fullPath);

  if (error && typeof error === "object" && "message" in error) {
    return error.message as string | undefined;
  }

  return undefined;
};
